<div
  [matMenuTriggerFor]="watchMenu"
  [ngStyle]="{
    border: isCurrentUserWatching ? '1px solid #ff6600' : '1px solid #f0f0f0',
    'background-color': isCurrentUserWatching ? '#ffefe7' : ''
  }"
  matTooltip="Watch Options"
  matTooltipPosition="above"
  class="watch-option"
  tabindex="0"
  >

  @if (watchUserDetail?.length > 0) {
    <mat-icon
      [ngStyle]="{ color: isCurrentUserWatching ? '#ff6600' : '' }"
      >visibility</mat-icon
      >
    }
    @if (watchUserDetail?.length === 0) {
      <mat-icon>visibility_off</mat-icon>
    }

    <span
      [ngStyle]="{ color: isCurrentUserWatching ? '#ff6600' : '' }"
      class="watch-count"
      >{{ watchUserDetail?.length }}</span
      >
    </div>

    <mat-menu #watchMenu="matMenu" class="watch-menu" (closed)="resetAddWatcherField()">
      <div
        class="menu-item top-row"
        mat-menu-item
        (click)="addLoginWatcher(); $event.stopPropagation()"
        >
        <mat-icon class="menu-icon">visibility</mat-icon>
        <span class="menu-text">{{
          isCurrentUserWatching ? "Stop watching" : "Start watching"
        }}</span>
      </div>

      <mat-divider></mat-divider>

      <div class="py-1" (click)="$event.stopPropagation()">
        <div class="watching-label pt-1 pb-2 px-3">Watching this issue</div>

        <div class="watcher-list">
          @for (watcher of watchUserDetail ; track watcher; let i = $index) {
            <div
              class="d-flex align-items-center px-3 user-info"
              >
              <app-profile-avatar
                [fullName]="watcher.user_full_name"
                [widthSize]="'30px'"
                [heightSize]="'30px'"
                [userStatusSlug]="loginUserID == watcher?.user_id ?  currentStatus : watcher?.UserStatusData?.user_status?.value ||'available'"
                [profileUrl]="watcher?.profile_image?.url"
              ></app-profile-avatar>
              <div class="username">{{ watcher.user_full_name }}</div>
              <span
                class="remove-icon"
                [matMenuTriggerFor]="watchingMenu"
                (click)="currentWatcher = watcher; $event.stopPropagation()"
                #childMenuTrigger="matMenuTrigger"
                >
                <span [innerHTML]="getSelectedOptionIcon(watcher.user_id)"></span>
                <mat-icon>more_vert</mat-icon>
              </span>
            </div>
          }
        </div>
      </div>

      <mat-divider></mat-divider>

      @if (!showAddWatcherField) {
        <div
          class="menu-item add-watchers"
          mat-menu-item
          (click)="toggleAddWatcherField(); $event.stopPropagation()"
          [class.disabled]="isAddingWatcher"
          >
          <mat-icon class="menu-icon">add</mat-icon>
          <span class="menu-text">
            @if (!isAddingWatcher) {
              Add watchers
            } @else {
              <span class="d-inline-flex align-items-center">
                <mat-progress-spinner
                  diameter="16"
                  strokeWidth="2"
                  mode="indeterminate"
                  class="convert-spinner"
                ></mat-progress-spinner>
                <span class="ml-2">Adding watcher...</span>
              </span>
            }
          </span>
        </div>
      }

      @if (showAddWatcherField) {
        <div
          class="px-3 search-container"
          (click)="$event.stopPropagation()"
          >
          <mat-form-field appearance="outline" class="w-100 search-watchers spinner-inline" subscriptSizing="dynamic">
            <mat-icon matPrefix class="account_circle_icon">account_circle</mat-icon>
            <input
              matInput
              placeholder="Add watchers"
              (change)="getUsersList($event)"
              #searchInput
              [matMenuTriggerFor]="staffList.length > 0 ? staffSearchMenu : null"
              #staffSearchMenuTrigger="matMenuTrigger"
              [disabled]="isAddingWatcher || isStaffSearchLoading"
              />
            @if (isStaffSearchLoading) {
              <span
                matSuffix
                class="searching-text"
                >
                Searching...
              </span>
            }
          </mat-form-field>
          @if (isAddingWatcher) {
            <div class="adding-spinner">
              <mat-progress-spinner
                diameter="16"
                strokeWidth="2"
                mode="indeterminate"
                class="convert-spinner"
              ></mat-progress-spinner>
              <span class="ml-2">Adding watcher...</span>
            </div>
          }
        </div>
      }
    </mat-menu>

    <mat-menu #watchingMenu="matMenu" [hasBackdrop]="false" class="child-menu">
      @for (option of watchOptions; track option) {
        <button
          mat-menu-item
          (click)="selectOption(option.name, currentWatcher?.user_id, $event)"
          >
          <span class="custom-svg-icon pr-1" [innerHTML]="option.icon"></span>
          <span>{{ option.name }}</span>
        </button>
      }
    </mat-menu>

    <mat-menu
      #staffSearchMenu="matMenu"
      class="staff-search-menu"
      [hasBackdrop]="false"
      >
      <div class="staff-list-container">
        @for (staff of staffList; track staff) {
          <div
            class="staff-item d-flex align-items-center py-2 px-3"
            (click)="onStaffSelected(staff)"
            [class.disabled]="isAddingWatcher || isStaffSearchLoading"
            >
            <app-profile-avatar
              [fullName]="staff.full_name"
              [widthSize]="'30px'"
              [heightSize]="'30px'"
              [userStatusSlug]="staff?.user_status?.value || 'available'"
              [profileUrl]="staff?.staff_detail?.profile_image?.url"
            ></app-profile-avatar>
            <div class="ml-2">
              <div class="staff-name">{{ staff.full_name }}</div>
            </div>
          </div>
        }
      </div>
    </mat-menu>

